// extracted by mini-css-extract-plugin
export default {"container":"zq-z","brandName":"Aq-z","productName":"Bq-z","productNamePdpEnhancements":"Cq-z","breakLongProductName":"Dq-z"};